import { useGlobalStore } from '@services/store/global-store';
import React, { createContext, useContext, useState } from 'react';

interface AuthContextType {
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const {
    resetUserDetails,
    resetMemberStore,
    resetBannerContent,
    resetAdminStore
  } = useGlobalStore((state) => state);
  const [refreshIntervalId, setRefreshIntervalId] = useState<number | null>(
    null
  );
  // const userSubType = useGlobalStore(
  //   (state) => state.userDetails.userInformation.userSubType
  // );
  // const cceName = useGlobalStore.getState().userDetails.userInformation.cceName;

  const userSubType = useGlobalStore(
    (state) => state.userDetails.userInformation.userSubType ?? ''
  );
  const cceName = useGlobalStore(
    (state) => state.userDetails.userInformation.cceName ?? ''
  );

  const login = () => {
    // startTokenRefresh();
  };

  const userState =
    useGlobalStore((state) => state.userDetails.userInformation.state) || '';

  const logout = () => {
    const state = userState || '';
    const localuserSubType = userSubType;
    const localcceName = cceName;
    console.log('Logging out user with state:', state);
    console.log('User SubType:', localuserSubType);
    console.log('CCE Name:', localcceName);
    const isSSOFlow = localuserSubType === 'SSO' && localcceName !== 'CCWW';
    sessionStorage.clear();
    if (isSSOFlow) {
      sessionStorage.setItem('SSOFLOW', 'true');
      sessionStorage.setItem('STATE', state);
    }
    // Clear React state and session storage
    resetUserDetails();
    resetMemberStore();
    resetAdminStore();
    resetBannerContent();
    useGlobalStore.getState().userDetails.jwtToken = '';
    if (refreshIntervalId) {
      clearInterval(refreshIntervalId);
      setRefreshIntervalId(null);
    }
    if (isSSOFlow) {
      console.log('SSO flow detected');
      window.location.replace('/logout');
    } else {
      console.log('Non-SSO flow detected');
      window.location.replace('/logout');
    }
  };

  return (
    <AuthContext.Provider value={{ login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
